// @ts-check
import { disableScroll, enableScroll } from "../utilities/scroll.js";
import { get, getAll, getById } from "../utilities/querySelector.js";


export class HTMLModalElement extends HTMLElement {
    constructor() {
        super();
        this._closeHandler = this.close.bind( this );
        this._backgroundClickHandler = function( e ) {
            if ( e.target === this ) this.close();
        };
        this._escPressHandler = function( e ) {
            if ( e.key === 'Escape' ) this.close();
        }.bind( this );
    }

    connectedCallback() {
        this.dispatchEvent( new Event( 'beforeconnectedcallback' ) );

        this.addEventListener( 'click', this._backgroundClickHandler );

        const closers = getAll( '[data-modal-close]' );
        closers.forEach( closer => {
            closer.addEventListener( 'click', this._closeHandler );
        } );

        this.dispatchEvent( new Event( 'afterconnectedcallback' ) );
    }

    disconnectedCallback() {
        this.removeEventListener( 'click', this._backgroundClickHandler );
    }

    open() {
        this.dispatchEvent( new Event( 'beforeopen' ) );
        this.setAttribute( 'open', '' );
        this.removeAttribute( 'aria-hidden' );
        disableScroll();
        this.dispatchEvent( new Event( 'afteropen' ) );
        get( '[data-modal-close]', this )?.focus();
        document.addEventListener( 'keydown', this._escPressHandler );
    }

    close() {
        document.removeEventListener( 'keydown', this._escPressHandler );

        this.setAttribute( 'aria-hidden', 'true' );
        this.removeAttribute( 'open' );
        enableScroll();
        this.dispatchEvent( new Event( 'afterclose' ) );
    }

}

customElements.define( 'nu-modal', HTMLModalElement );


const enquiryModalLinks = getAll( '[href="#get-a-quote"]' );
const enquiryModal = /** @type HTMLModalElement */( getById( 'enquiry-modal' ) );
if ( enquiryModal ) {
    enquiryModalLinks.forEach( link => {
        link.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            enquiryModal.open();
            enquiryModal.addEventListener( 'afterclose', () => {
                link.focus();
            }, { once: true } );
        } );
    } );
}


const supportModalLinks = getAll( '[href$="#support-form"]' );
const supportModal = /** @type HTMLModalElement */( getById( 'support-modal' ) );
if ( supportModal ) {
    supportModalLinks.forEach( link => {
        link.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            supportModal.open();
            supportModal.addEventListener( 'afterclose', () => {
                link.focus();
            }, { once: true } );
        } );
    } );
}


const questionModalLinks = getAll( '[href="#find-my-heat-pump"]' );
const questionModal = /** @type HTMLModalElement */( getById( 'questions-modal' ) );
if ( questionModal ) {
    questionModalLinks.forEach( link => {
        link.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            questionModal.open();
            questionModal.addEventListener( 'afterclose', () => {
                link.focus();
            }, { once: true } );
        } );
    } );
}